import ProfileStore from './store';
import {
  CONFIRM_DELETE_TEXT,
  CONFIRM_DELETE_HEADER,
} from '@/pages/profile/blocks/children/sidebar/const';
import { InitialState, IPopup, IMentoringPopup } from './types';

const popup: IPopup = {
  isModalWindow: false,
  modalText: CONFIRM_DELETE_TEXT,
  modalHeader: CONFIRM_DELETE_HEADER,
  method: '',
  isSidebarButtons: false,
  isDefaultButtons: true,
  isNoButtons: false,
  acceptButtonText: 'Да',
  declineButtonText: 'Нет',
  confirmed: false,
};

const mentoringPopup: IMentoringPopup = {
  isWindowOpen: false,
  popupFormData: null,
};

const initialState: InitialState = {
  id: '',
  fio: '',
  selector: 0,
  modal: false,
  popup,
  mentoringPopup,
};

const store: ProfileStore<InitialState> = new ProfileStore<InitialState>(
  initialState,
);

export * from './types';
export default store;



// WEBPACK FOOTER //
// ./src/pages/profile/store/index.ts